import React, { useState, useEffect } from 'react';
import { Modal, Form, Table } from 'react-bootstrap';
//Modules 
import * as XLSX from 'xlsx';

//API
import { BankConsilationFetchAPI } from '../../../api/BankConsilation';
//Alerts
import ErrorAlert from '../../Alerts/ErrorAlert';
import SuccessAlert from '../../Alerts/SuccessAlert';
import LoadingAlert from '../../Alerts/LoadingAlert';


const BankTemplate = ({ integrations, token, business_code, eventHandlerShowTemplateModal, setEventHandlerShowTemplateModal }) => {
    const [showModal, setShowModal] = useState(false)
    const [bankStatementTemplate, setBankStatementTemplate] = useState(null);
    const [bankStatementTemplateName, setBankStatementTemplateName] = useState(null);
    const [bankSelected, setBankSelected] = useState(null);
    const [headers, setHeaders] = useState([]);
    const [previewData, setPreviewData] = useState([]);

    const [mapping, setMapping] = useState({
        date: "",
        reference: "",
        debit: "",
        credit: "",
    });
    const [step, setStep] = useState(1); // Estado para el paso actual
    const totalSteps = 4; // Número total de pasos
    const [file, setFile] = useState(null);

    const nextStep = () => {
        if (step < totalSteps) setStep(step + 1);
    };

    const prevStep = () => {
        if (step > 1) setStep(step - 1);
    };

    useEffect(() => {
        if (!showModal) {
            setStep(1);
        }
    }, [showModal]);

    // We save the mapping and close the modal
    const handleSaveMapping = async () => {
        LoadingAlert("Guardando mapeo", "Guardando el mapeo de columnas...");
        try {
            const response = await BankConsilationFetchAPI.saveBankStatementTemplate(token, bankSelected, business_code, mapping, bankStatementTemplateName);
            setBankStatementTemplate(mapping);
            SuccessAlert("Mapeo guardado", "El mapeo se ha guardado correctamente", "success");
        } catch (err) {
            ErrorAlert("Error al guardar el mapeo", err.message, "error");
        }
        setShowModal(false);
    };

    // Manage of change of mapping excel columns 
    const handleMappingChange = (key, value) => {
        setMapping((prev) => ({ ...prev, [key]: value }));
    };

    //Dropzone fILE
    const [fileName, setFileName] = useState('No hay ningún archivo seleccionado');

    const handleFileChange = (e) => {
        if (e.target.files.length > 0) {
            setFileName(e.target.files[0].name);
        } else {
            setFileName('No hay ningún archivo seleccionado');
        }
    };

    // Upload of excel 
    const handleFileUpload = (e) => {
        //We just allow to upload  the file if the bank statement template is null
        const uploadfile = e.target.files[0];
        setFile(uploadfile);
        if (!uploadfile) return;

        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: "array" });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
            const headers = jsonData[0];
            setHeaders(headers);
            setPreviewData(jsonData.slice(1)); // Guarda los datos (sin los encabezados)
            if (bankStatementTemplate === null) {
                setShowModal(true); // Muestra el modal para mapeo
            }
        };
        reader.readAsArrayBuffer(uploadfile);
    };
    // We convert the excel date to JS date
    const excelDateToJSDate = (serial) => {
        const utc_days = Math.floor(serial - 25569);
        const utc_value = utc_days * 86400; // 86400 segundos en un día
        const date_info = new Date(utc_value * 1000);
        return date_info; // Esto devuelve un objeto Date
    };
    // We format the date to YYYY-MM-DD
    const formatExcelDate = (serial) => {
        const date = excelDateToJSDate(serial);
        return date.toISOString().split('T')[0]; // Resultado: '2023-12-30'
    };

    // Show prev table mapped data 
    const renderPreviewTable = () => {
        const mappedData = previewData.map((row) => ({
            date: row[headers.indexOf(mapping.date)],
            reference: row[headers.indexOf(mapping.reference)],
            description: row[headers.indexOf(mapping.description)],
            debit: row[headers.indexOf(mapping.debit)],
            credit: row[headers.indexOf(mapping.credit)],
        }));

        return (
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>Referencia</th>
                        <th>Descripción</th>
                        <th>Débito</th>
                        <th>Crédito</th>
                    </tr>
                </thead>
                <tbody>
                    {mappedData.map((row, index) => (
                        <tr key={index}>
                            <td>{typeof row.date === "number" ? formatExcelDate(row.date) : row.date}</td>
                            <td>{row.reference}</td>
                            <td>{row.description}</td>
                            <td>{row.debit}</td>
                            <td>{row.credit}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        );
    };

    useEffect(() => {
        if (eventHandlerShowTemplateModal) {
            setShowModal(true);
        }
        setEventHandlerShowTemplateModal(0)
    }, [eventHandlerShowTemplateModal]);

    return (
        <>
            <div>
                <button className='btn btn-light bg-white btn-sm  fw-normal text-dark border border-1 rounded-2 text-nowrap '
                    onClick={() => (setShowModal(true))} >
                    Crear Plantilla Bancaria
                </button>
            </div>

            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size='xl'
                centered>
                <Modal.Body>

                    <div className='position-relative '>

                        <div className='position-absolute top-0 start-100 translate-middle mt-2 '>
                            <div className='me-3'>
                                <button class="btn btn-outline-secondary border-0 bg-light text-secondary rounded-circle p-2 lh-1"
                                    type="button" title='Cerrar'
                                    onClick={() => setShowModal(false)}

                                >
                                    <i class="uil uil-multiply"></i>
                                </button>
                            </div>
                        </div>
                        <h2 className="title-main-login  text-center ">
                            Crear Plantilla Bancaria
                        </h2>

                        <div>

                            {/* ******** Step 01 ******** */}
                            <div className={`paso ${step === 1 ? "activo" : ""}`}>

                                <Form.Group className="my-5">
                                    <Form.Label className='text-black fw-semibold'>¿Cómo desea nombrar esta plantilla bancaria?</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Ingresar..."
                                        name="name"
                                        value={bankStatementTemplateName}
                                        onChange={(e) => setBankStatementTemplateName(e.target.value)}
                                    />
                                </Form.Group>
                            </div>

                            {/* ******** Step 02 ******** */}
                            <div className={`paso ${step === 2 ? "activo" : ""}`}>
                                <Form.Label className='text-black fw-semibold'>Subir Excel de estado bancario</Form.Label>
                                <div className=" p-3 bg-white rounded-3 border mt-1">
                                    <h6 className="fw-semibold">Subir Archivo </h6>
                                    <div className="dropzone-container">
                                        <label htmlFor="dropzone-file" className="dropzone-label">
                                            <div className="dropzone-content">
                                                <svg
                                                    className="dropzone-icon"
                                                    aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 20 16"
                                                >
                                                    <path
                                                        stroke="currentColor"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="2"
                                                        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                                                    />
                                                </svg>
                                                <p className="dropzone-text">
                                                    <span className="dropzone-bold">Haga clic para cargar archivo de Estado de Cuenta Bancario </span>
                                                </p>

                                                <p className="file-name">{fileName}</p>
                                            </div>
                                            <input
                                                id="dropzone-file"
                                                type="file"
                                                accept=".xlsx, .xls"
                                                className="dropzone-input"
                                                onChange={(event) => {
                                                    handleFileChange(event);
                                                    handleFileUpload(event);
                                                }}
                                            />
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {/* ******** Step 03 ******** */}
                            <div className={`paso ${step === 3 ? "activo" : ""}`}>
                                <Form.Label className='text-black fw-semibold'>Seleccione el banco para la integracion a guardar:</Form.Label>
                                <Form.Select
                                    value={bankSelected}
                                    onChange={(e) => setBankSelected(e.target.value)}
                                >
                                    <option value="">Seleccione...</option>
                                    {integrations.map((integration, index) => (
                                        <option key={index} value={integration.name}>
                                            {integration.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                            {/* ******** Step 04 ******** */}
                            <div className={`paso ${step === 4 ? "activo" : ""}`}>
                                <Form.Label className='text-black fw-semibold'>Selecciona las columnas correspondientes:</Form.Label>
                                <Form>
                                    {['date', 'reference', "description", 'debit', 'credit'].map((key) => (
                                        <Form.Group key={key} className="mb-3">
                                            <Form.Label>{key.charAt(0).toUpperCase() + key.slice(1)}</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={mapping[key]}
                                                onChange={(e) => handleMappingChange(key, e.target.value)}
                                            >
                                                <option value="">Seleccionar columna</option>
                                                {headers.map((header, index) => (
                                                    <option key={index} value={header}>
                                                        {header}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    ))}
                                </Form>
                                {/* Preview of data */}
                                {previewData.length > 0 && renderPreviewTable()}

                                <div className="mt-3 d-flex justify-content-end">
                                    <button className="btn btn-save-sp" onClick={handleSaveMapping}>
                                        Guardar
                                    </button>
                                </div>
                            </div>

                            <div className="botones-navegacion">
                                <button onClick={prevStep} disabled={step === 1} type="button">
                                    Anterior
                                </button>
                                <button onClick={nextStep} disabled={step === totalSteps} type="button" >
                                    Siguiente
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    )
}

export default BankTemplate